import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController,LoadingController } from '@ionic/angular';
import { StylistSaleTipRow, StylistSaleTipSummaryRow, ReportService } from '../../services/report.service';
import { SaleService } from '../../services/sale.service';
import { UserService } from '../../services/user.service';
import { Stylist } from '../../models/stylist/stylist.model';
import { Utilities } from '../../utilities/utilities';
import { SMPickerRange } from '../../components/smr-date-picker/smr-date-picker.component';
import { StylistPickerComponent } from '../../components/stylist-picker/stylist-picker.component';
// import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics';
import { ExportTableService } from "../../services/export-table.service";
import { CalendarService } from "../../services/calendar.service";
import { ChartsService} from "../../services/charts.service";
import { Router } from '@angular/router';
import { ChartType, ChartTypeRegistry } from 'chart.js';


interface primeNgCol {
  field: string;
  header: string
}
type MyChartTypeRegistry = {
  bar: ChartType;
  line: ChartType;
  radar: ChartType;
  // ... other chart types
};
@Component({
  selector: 'app-tips-report',
  templateUrl: './tips-report.page.html',
  styleUrls: ['./tips-report.page.scss'],
})
export class TipsReportPage implements OnInit {

 // @ViewChild(Content) content: Content;

  @ViewChild(StylistPickerComponent) stylistPickerComponent: StylistPickerComponent;

  public stylistTips: Array<StylistSaleTipRow>;

  public cols: primeNgCol[];

  public allStaffCols: {field: string, header: string}[];

  public stylistTotalSales: number;

  public stylistServiceCommissionTotal: number;

  public stylistRetailCommissionTotal: number;

  public yearIndicator: boolean = false;

  public xAxisDateChanger: string;

  public stylistID: number;

  public stylist: Stylist;

  public readOnlyStylistPicker: boolean;

  public isLoading: boolean = true;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public errorOccurredWhileLoadingStats: boolean;

  public startDate: Date;

  public endDate: Date;
  public stylistTotalTip: number;

  public allStaffRows: Array<StylistSaleTipSummaryRow>;

  public barChartOptions: any;

  public barChartLabels:string[] = [];

  public barChartType: keyof MyChartTypeRegistry = 'bar';

  public barChartLegend:boolean = true;

  public barChartData:any[] = [];

  public barChartColors: object[] = [];

  constructor (
               public reportService: ReportService,
               public userService: UserService,
               private saleService: SaleService,
               public alertController: AlertController,
               public loadingCtrl: LoadingController,
               private ExportTableService: ExportTableService,
               private CalendarService: CalendarService,
               private ChartsService: ChartsService,
               private router: Router
               // private googleAnalytics: GoogleAnalytics,
  ) {
    for(let i = 0; i < 17; i++) {
      this.barChartColors.push(ChartsService.chartColorArrayFunction(Utilities.colorSpectrumRGB[i][0], Utilities.colorSpectrumRGB[i][1], Utilities.colorSpectrumRGB[i][2], 0.8))
    }
    this.stylistTips = [];
    this.allStaffRows = [];
    this.cols = [
      { field: 'uuid', header: "Sale ID"},
      { field: 'datetime', header: "Date"},
      { field: 'clientName', header: "Client"},
      { field: 'tipsTotal', header: "Amount"}
    ];
    this.allStaffCols = [
      { field: 'stylistFullName', header: "Stylist"},
      { field: 'totalTips', header: "Amount"}
    ];

    this.barChartOptions = ChartsService.barChartOption('', 'top');
    const currency = this.userService.getSalon().getCurrency();
    this.barChartOptions.scales.xAxes = [{
      ticks: {
        callback: function(value, index, values) {
          return Utilities.decodeHTML(currency) + value;
        }
      }
    }];
    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      this.readOnlyStylistPicker = !(user.isAdministrator() || user.getCanViewReports() === 1);
    }
  }


  public ngOnInit () {
    // this.googleAnalytics.trackView('TipsReportPage')
    //   .then(() => {
    //   })
    //   .catch(() => {
    //   });
    if (!this.startDate) {
      let dateFromCache: string = localStorage.getItem('datePickerStartDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.startDate = Utilities.parseDate(dateFromCache);
      }
    }

    if (!this.endDate) {
      let dateFromCache: string = localStorage.getItem('datePickerEndDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.endDate = Utilities.parseDate(dateFromCache);
      }
    }
  }

  public ngAfterViewInit () {
    if(this.stylist) {
      this.loadStats(this.stylist, this.startDate, this.endDate);
    }
  }

  public onStylistPickerInit (initResponse: {success: boolean, stylist: Stylist}) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
    }
  }

  public onStylistSelect (stylist: Stylist) {
    this.isLoading = false;
    if (stylist) {
      this.stylistID = stylist.getID();
      this.stylist = stylist;
      this.loadStats(stylist, this.startDate, this.endDate);
    }
  }

  public onTapToReload () {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStylistPicker = false;
    this.errorOccurredWhileLoadingStats = false;
    this.stylistPickerComponent.ngOnInit();
  }

  public rangeChanged (dateRange: SMPickerRange) {
    this.startDate = dateRange.start;
    this.endDate = dateRange.end;
    this.timeManager(dateRange.start, dateRange.end);
    this.loadStats(this.stylist, this.startDate, this.endDate);
  }

  public loadStats (stylist: Stylist, startDate: Date, endDate: Date) {
    this.timeManager(startDate, endDate);
    this.isLoading = true;
    this.errorOccurredWhileLoadingStats = false;

    this.stylistTips = [];
    this.allStaffRows = [];
    this.stylistTotalSales = 0;
    this.stylistServiceCommissionTotal = 0;
    this.stylistRetailCommissionTotal = 0;
    this.barChartData = [];

    if (stylist.id === 0) {
      this.reportService.loadAllStaffTipsStats(startDate, endDate)
        .subscribe({
          next: (rows) => {
            this.allStaffRows = rows;
            this.isLoading = false;

            this.allStaffRows.forEach((stat) => {
              this.barChartData.push({
                data: [stat.totalTips],
                label: stat.stylistFullName
              });
            });

            //this.content.resize();
          },
          error: (e) => {
            this.isLoading = false;
            this.errorOccurredWhileLoadingStats = true;
            //this.content.resize();
          }
        });

    } else {
      this.reportService.loadStylistTipsStats(stylist.id, startDate, endDate)
        .subscribe({
          next: (rows) => {
            this.stylistTips = rows;
            this.isLoading = false;
            this.stylistTotalTip = this.getTotalTipsByStylist();
            //this.content.resize();
          },
          error: (e) => {

            this.isLoading = false;
            this.errorOccurredWhileLoadingStats = true;
            //this.content.resize();
          }
        });
    }
  }

  public timeManager (dateRangeStart, dateRangeEnd) {
    let resObj = this.CalendarService.timeManager(dateRangeStart, dateRangeEnd);
    this.xAxisDateChanger = resObj.xAxisDateChanger;
    this.yearIndicator = resObj.yearIndicator;
  }

  public summaryTotalTips ()  {
    return this.allStaffRows.map(row =>  row['totalTips'])
      .reduce((res, cell) => res += cell, 0);
  }

  public getTotalTipsByStylist ()  {
    this.stylistTips.forEach(element => {
    });
    return this.stylistTips.map(row =>  Number(row['tipsTotal']))
      .reduce((res, cell) => res += cell, 0);
  }
  public exportPdf (staff?) {
    if(staff === 'one') {
      this.ExportTableService.exportPdf(this.stylistTips.map(stylistTip => {
        return {
          uuid: stylistTip.uuid,
          datetime: Utilities.formatDate(stylistTip.datetime, 'ddd, MMMM D, Y'),
          clientName: stylistTip.clientName,
          tipsTotal: stylistTip.tipsTotal
        };
      }), "Tips", this.cols);
    } else {
      this.ExportTableService.exportPdf([...this.allStaffRows.map(stylistTip => {
        return {
          stylistFullName: stylistTip.stylistFullName,
          totalTips: stylistTip.totalTips
        };
      }), {stylistFullName: 'Total', totalTips: this.summaryTotalTips().toFixed(2)}], "All Staff Tips", this.allStaffCols);
    }
  }

  public exportExcel (staff?) {
    if(staff === 'one') {
      this.ExportTableService.exportExcel(this.stylistTips.map(stylistTip => {
        return {
          uuid: stylistTip.uuid,
          datetime: Utilities.formatDate(stylistTip.datetime, 'ddd, MMMM D, Y'),
          clientName: stylistTip.clientName,
          tipsTotal: stylistTip.tipsTotal
        };
      }), "Tips", this.cols.map(col => col.header));
    } else {
      this.ExportTableService.exportExcel([...this.allStaffRows.map(stylistTip => {
        return {
          stylistFullName: stylistTip.stylistFullName,
          totalTips: stylistTip.totalTips
        };
      }), {stylistFullName: 'Total', totalTips: this.summaryTotalTips().toFixed(2)}], "All Staff Tips", this.allStaffCols.map(col => col.header));
    }
  }

  public onBack () {
    this.router.navigateByUrl('/report-list');
  }

}
